import { useMemo, useState } from "react";

interface ImageLoaderProps {
  src: string;
  className?: string;
  onLoad?: () => void;
  onError?: () => void;
  "data-testid"?: string;
}

const ImageLoader = ({
  src,
  className,
  onLoad,
  onError,
  "data-testid": dataTestId,
}: ImageLoaderProps) => {
  return (
    <img
      data-testid={dataTestId}
      className={className}
      src={src}
      alt="No Img"
      onLoad={onLoad}
      onError={onError}
    />
  );
};

interface ImageWithFallbackProps {
  thumbImage: ImageLoaderProps;
  plainImage: ImageLoaderProps;
  className?: string;
  onLoad?: () => void;
  onError?: () => void;
}

const ImageWithFallback = ({
  thumbImage,
  plainImage,
  className,
  onLoad,
  onError,
}: ImageWithFallbackProps) => {
  const [useThumb, setUseThumb] = useState(true);

  const src = useMemo(
    () => (useThumb && thumbImage?.src ? thumbImage.src : plainImage.src),
    [thumbImage?.src, plainImage.src, useThumb]
  );

  const handleError = () => {
    console.error(`Failed to load image: ${src}. Falling back to plain image.`);
    setUseThumb(false);
    onError?.();
  };

  return (
    <ImageLoader
      src={src}
      className={className}
      onLoad={onLoad}
      onError={handleError}
      data-testid={"image-with-fallback"}
    />
  );
};

export default ImageWithFallback;
